module.exports = __webpack_public_path__ + "img/close.324c0516.png";